function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.227 7.753a2 2 0 001.44-.586l1.886-1.887a.667.667 0 10-.946-.94L11.7 6.22a.667.667 0 01-.947 0l2.36-2.353a.668.668 0 00-.73-1.092.669.669 0 00-.216.145L9.813 5.28a.667.667 0 010-.94L11.7 2.453a.67.67 0 00-.947-.946L8.867 3.393a2 2 0 000 2.827L8 7.08 2.487 1.547l-.067-.04a.473.473 0 00-.113-.074l-.12-.046-.08-.054h-.18a.38.38 0 00-.12 0 .467.467 0 00-.114.06l-.106.067H1.54l-.04.067a.667.667 0 00-.073.113.713.713 0 00-.047.127v.073a7.333 7.333 0 002.073 6.227l1.76 1.753-3.606 3.6a.667.667 0 00.473 1.14.666.666 0 00.473-.193L6.6 10.38l1.887-1.887L9.82 7.16a2 2 0 001.407.593zm-5.1 1.214l-1.754-1.76A6.04 6.04 0 012.667 3.6L7.073 8l-.946.967zm4.16.38a.672.672 0 00-.954.946l4.2 4.2a.667.667 0 00.467.174.666.666 0 00.473-1.14l-4.186-4.18z",
  fill: "#4F4F4F"
});

function SvgForkKnifeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
}

export default SvgForkKnifeIcon;